import { INTERCOM_BASE_SETTINGS } from '../constants';
import { IntercomSettings } from '../models/intercom.model';
import { getAccountInfo } from './getAccountInfo';
import { getVerificationHash } from './getVerificationHash';

const updateIntercomSettings = (settings: Partial<IntercomSettings>) => {
  const newSettings = {
    ...INTERCOM_BASE_SETTINGS,
    ...settings,
  };
  window.intercomSettings = newSettings;
};

const rebootIntercom = () => {
  if (window.intercomSettings) {
    window.Intercom('shutdown');
    window.Intercom('boot', window.intercomSettings);
    window.Intercom('show');
  }
};

export const bootIntercomWithUserHash = async () => {
  const clearSettings: Partial<IntercomSettings> = {
    email: undefined,
    user_id: undefined,
    user_hash: undefined,
  };

  const accountInfoResponse = await getAccountInfo();
  const verificationResponse = await getVerificationHash();

  if (
    verificationResponse.status === 'UNAUTHORIZED' ||
    accountInfoResponse.status === 'UNAUTHORIZED'
  ) {
    updateIntercomSettings(clearSettings);
    rebootIntercom();
    return;
  }

  let userDataAndHash: Partial<IntercomSettings> = {};

  if (
    verificationResponse.status === 'OK' &&
    accountInfoResponse.status === 'OK'
  ) {
    userDataAndHash = {
      user_hash: verificationResponse.hash,
      user_id: accountInfoResponse.accountInfo.id,
      email: accountInfoResponse.accountInfo.email,
    };
  }

  updateIntercomSettings(userDataAndHash);
  rebootIntercom();
};
